import { render, staticRenderFns } from "./tableBasic.vue?vue&type=template&id=4a4a5e04"
import script from "./tableBasic.vue?vue&type=script&lang=js"
export * from "./tableBasic.vue?vue&type=script&lang=js"
import style0 from "./tableBasic.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports